import React, { useContext, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useStyles } from '../styles';
import { Typography, Box, Card, CardContent, Grid, Avatar, IconButton, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, Divider, Tabs,
  Tab } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import PolicyIcon from '@mui/icons-material/Policy';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RedeemIcon from '@mui/icons-material/Redeem';
import DownloadIcon from '@mui/icons-material/Download';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { getParameterByName } from '../util';
import { Store } from '../Store';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';




const ProfileDetails = (props) => {
  const { state } = useContext(Store);
  let { setting } = state.userSetting ;
   const styles = useStyles();
   if(!setting){
    setting=JSON.parse(localStorage.getItem("userInfo"));
  }
  const themeColor = setting.themeColor || '#543A20';
  const themeTxtColor = setting.themeTxtColor || '#CE9760';
   const history = useHistory();
    const [tabSel, setTabSel] = React.useState(3);
  let profile = null;
  try {
    const storedProfile = sessionStorage.getItem('customerInfo');
    profile = storedProfile ? JSON.parse(storedProfile) : null;
  } catch (error) {
    console.error('Error parsing profile data from sessionStorage', error);
  }
  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }
  // Retrieve merchantCode from the query params (fallback example: ?merchantCode=UPT99FLCPJ)
  const queryMerchantCode = getParameterByName('merchantCode');

  // Return default value if data is missing (except for phone)
  const getDefault = (value, defaultValue) =>
    value && value.toString().trim() !== '' ? value : defaultValue;

  // Generate initials from firstName and lastName
  const getInitials = (firstName, lastName) =>
    `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();

  const backUrl = queryMerchantCode
    ? `/?merchantCode=${queryMerchantCode}` 
    : '/';

const goto =(subpath) =>{
      history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }

const logout= () =>{
  sessionStorage.removeItem("customerInfo");
  goto("");

}
  // List items config
  const options = [
    { label: 'My Orders', icon: <ListAltIcon />, onClick: () => {goto("myorders");} },
    { label: 'Rewards', icon: <RedeemIcon />, onClick: () => {goto("rewards");} },
    { label: 'Privacy policy', icon: <PolicyIcon />, onClick: () => {goto("policy");} },
    { label: 'Invite Friend', icon: <GroupAddIcon />, onClick: () => {goto("invitefriend");} },
    { label: 'Install App', icon: <DownloadIcon />, onClick: () => { window.dispatchEvent(new CustomEvent('open-pwa-install')); } },
    { label: 'Logout', icon: <LogoutIcon />, onClick: () => {logout()} },
  ];

  return (
    <Box
       className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor, overflow:"hidden!important" }}
    >
      <Box style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
     
        <IconButton onClick={() => (goto("order"))}>
          <ArrowBackIcon sx={{ color: themeTxtColor }} fontSize="medium" />
        </IconButton>
        <IconButton>
          <NotificationsNoneIcon sx={{ color: themeTxtColor }} fontSize="medium" />
        </IconButton>
      </Box>

      <Box style={{width:"100%", textAlign:"center"}}>
        <Box style={{width:"100%", textAlign:"center", display:"flex", justifyContent:"center"}}>
          <Avatar
            style={{
              width: "100px",
              height: "100px",
              background: setting.themeTxtColor,
              fontSize: 36,
              boxShadow: 3,
              border: `4px solid #fff`,
            }}
          >
            {profile ? getInitials(getDefault(profile.customer.firstName, 'N'), getDefault(profile.customer.lastName, '')) : '?'}
          </Avatar>
          
        </Box>
        <Typography variant="h6" sx={{ color: themeTxtColor, fontWeight: 600, mt: 2 }}>
          {profile ? `${getDefault(profile.customer.firstName, 'No Name')} ${getDefault(profile.customer.lastName, '')}` : 'No Name'}
        </Typography>
      </Box>

    
      <Card style={{padding:"0px 10px", width: '100%',textAlign:'center',marginTop:"20px",  borderRadius: 4, boxShadow: 3, background: setting.themeColor }}>
        <List>
          {options.map((option, idx) => (
            <React.Fragment key={option.label}>
              <ListItem button onClick={option.onClick} sx={{ borderRadius: 3, mb: 1, color: themeTxtColor, '&:hover': { background: themeTxtColor, color: themeColor } }}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: themeTxtColor, color: themeColor }}>
                    {option.icon}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={option.label} primaryTypographyProps={{ fontWeight: 500 }} />
                <ListItemSecondaryAction>
                  <ChevronRightIcon sx={{ color: themeTxtColor }} />
                </ListItemSecondaryAction>
              </ListItem>
              {idx < options.length - 1 && <Divider variant="inset" component="li" sx={{ borderColor: themeTxtColor, opacity: 0.3 }} />}
            </React.Fragment>
          ))}
        </List>
      </Card>
      <Tabs 
        style={{
          backgroundColor: setting.themeTxtColor,
          borderTop: "2px solid " + setting.themeColor,
          padding:"6px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
    </Box>
  );
};

export default ProfileDetails;
